/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.framework.folders.rpc.FoldersRpc
 */

export const createFolderRpc = {
  serviceName: 'com.hubspot.framework.folders.rpc.FoldersRpc',
  rpcName: 'createFolder',
  auth: 'app',
  fingerprint: 'VNwAX0OgltpgX9pK11Ne6ifLQwjoSXFW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createFolderWithMetadataRpc = {
  serviceName: 'com.hubspot.framework.folders.rpc.FoldersRpc',
  rpcName: 'createFolderWithMetadata',
  auth: 'app',
  fingerprint: 'tZxp7Nz4TNlgX9pK11Ne6ifLQwjoSXFW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteFolderRpc = {
  serviceName: 'com.hubspot.framework.folders.rpc.FoldersRpc',
  rpcName: 'deleteFolder',
  auth: 'app',
  fingerprint: 'Xh7GoF9oT8EKajr86kmtiSfLQwjoSXFW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const renameFolderRpc = {
  serviceName: 'com.hubspot.framework.folders.rpc.FoldersRpc',
  rpcName: 'renameFolder',
  auth: 'app',
  fingerprint: 'NhsxynrBT3n6cGWlLEfrECfLQwjoSXFW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const moveFolderRpc = {
  serviceName: 'com.hubspot.framework.folders.rpc.FoldersRpc',
  rpcName: 'moveFolder',
  auth: 'app',
  fingerprint: '29H9EzTUa2wKajr86kmtiSfLQwjoSXFW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOrderedFoldersInThePathRpc = {
  serviceName: 'com.hubspot.framework.folders.rpc.FoldersRpc',
  rpcName: 'getOrderedFoldersInThePath',
  auth: 'app',
  fingerprint: 'nMJeNKCr9jk44UOes_IjhCfLQwjoSXFW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getFoldersByParentIdRpc = {
  serviceName: 'com.hubspot.framework.folders.rpc.FoldersRpc',
  rpcName: 'getFoldersByParentId',
  auth: 'app',
  fingerprint: 'nU8YzDPLJso44UOes_IjhCfLQwjoSXFW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getsFoldersByIdsRpc = {
  serviceName: 'com.hubspot.framework.folders.rpc.FoldersRpc',
  rpcName: 'getsFoldersByIds',
  auth: 'app',
  fingerprint: 'SPTrv2pnRec44UOes_IjhCfLQwjoSXFW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getFoldersRpc = {
  serviceName: 'com.hubspot.framework.folders.rpc.FoldersRpc',
  rpcName: 'getFolders',
  auth: 'app',
  fingerprint: 'iwUX-O8lfyA44UOes_IjhCfLQwjoSXFW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};